import React from "react";


const FAQ = () =>{
    return(
        <>
         <div id="faq">
    <div className="container">
      <div className="row d-flex align-items-center">
        <div className="col-lg-12">
          <div className="mb-30px">
            <div className="section-heading theme-text-center">
              <h1 className="head-back-light">Questions</h1>
              <h2 className="head-after">Faq's</h2>
            </div>
          </div>
        </div>
        <div className="col-lg-4">
          <div className="faq-item">
            <div className="faq-img">
              <img src="assets/images/img-5.png" alt="" />
            </div>
          </div>
        </div>
        <div className="col-lg-8">
          <div id="accordion" className="faq-accordion">
            <div className="collapse-head">
              <div className="collapse-btn">
                <button
                  className="collapsed"
                  data-toggle="collapse"
                  data-target="#content-one"
                  aria-expanded="true"
                >
                  <i className="mdi mdi-plus mdi-24px" />
                  Why should I hire an event planner?
                </button>
              </div>
              <div
                id="content-one"
                className="collapse show"
                data-parent="#accordion"
              >
                <div>
                  <p>
                  There are many reasons why you should hire an event planner. 
                  Event planners have the experience and expertise to plan and execute a successful event, 
                  freeing up your time and energy to focus on other things. 
                  They can also help you save money by negotiating with vendors and finding ways to maximize your budget.
                  </p>
                </div>
              </div>
            </div>
            <div className="collapse-head">
              <div className="collapse-btn">
                <button
                  className="collapsed"
                  data-toggle="collapse"
                  data-target="#content-two"
                  aria-expanded="false"
                >
                  <i className="mdi mdi-plus mdi-24px" />
                  What does home insurance cover?
                </button>
              </div>
              <div
                id="content-two"
                className="collapse"
                data-parent="#accordion"
              >
                <div>
                  <p>
                  Home insurance typically covers your home from fire, theft, and other damage. 
                  It may also cover your personal belongings, liability if someone is injured on your property, 
                  and living expenses if you are displaced from your home due to a covered event.
                  </p>
                </div>
              </div>
            </div>
            <div className="collapse-head">
              <div className="collapse-btn">
                <button
                  className="collapsed"
                  data-toggle="collapse"
                  data-target="#content-three"
                  aria-expanded="false"
                >
                  <i className="mdi mdi-plus mdi-24px" />
                  How much life insurance do I need?
                </button>
              </div>
              <div
                id="content-three"
                className="collapse"
                data-parent="#accordion"
              >
                <div>
                  <p>
                  The amount of life insurance you need will depend on your individual circumstances, such as your debts, 
                  your family's financial needs, and your income.
                  </p>
                </div>
              </div>
            </div>
            <div className="collapse-head">
              <div className="collapse-btn">
                <button
                  className="collapsed"
                  data-toggle="collapse"
                  data-target="#content-four"
                  aria-expanded="false"
                >
                  <i className="mdi mdi-plus mdi-24px" />
                  How much does your event planning cost?
                </button>
              </div>
              <div
                id="content-four"
                className="collapse"
                data-parent="#accordion"
              >
                <div>
                  <p>
                  The cost of our event planning will vary depending on the type and size of your event. 
                  However, you can expect to spend anywhere from a few hundred cedis to hundreds of thousands of cedis.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
        </>
    )
}
export default FAQ